import { Component } from '@angular/core';
import { NgxTippyService } from 'ngx-tippy-wrapper';

import { followCursor } from 'tippy.js';
import { SharedUiService } from './shared/services/shared-ui.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'writer-ai-frontend';
  constructor (private tippyService: NgxTippyService, public sharedUiService: SharedUiService) {
    this.tippyService.setDefaultProps({
      plugins: [followCursor],
      placement: 'auto',
      followCursor: true,
      theme: 'light',
      arrow: true,
      delay: [200, 0],
      duration: [190, 0],

      animation: 'shift-toward-extreme',
      allowHTML: true
    })
  }
}
